import { Button, styled } from '@mui/material';

export const ResourceButton = styled(Button)(({ theme: { palette } }) => ({
  border: 'none',
  padding: '0px 10px 0px 0px',
  fontSize: 13,
  color: palette.horizonText.main,
  backgroundColor: 'none',
  '&:hover': {
    backgroundColor: 'none',
  },
}));
